import psHttp from '@patsnap/common-ps-http';
import { emailAlertApiUrlPrefix } from '../../config/constants';

export function createEmailAlertApi({
    email,
    alert_title,
    alert_source,
    alert_type,
    alert_send,
    alert_frequency_type,
    alert_frequency_date,
    patent_count,
    folder_ids,
    workspace_id,
    send_to_myself,
    terms_of_use,
    alert_no_update,
    wechat_alert_on,
    exclude_own_comment,
    custom_fields,
    merged,
    query,
    efq,
    patent_type_and_country,
    ignore_title_length,
}) {
    return psHttp({
        url: `${emailAlertApiUrlPrefix}/emailalert/alert`,
        method: 'POST',
        data: {
            email,
            alert_title,
            alert_source,
            alert_type,
            alert_send,
            alert_frequency_type,
            alert_frequency_date,
            patent_count,
            folder_ids,
            workspace_id,
            send_to_myself,
            terms_of_use,
            alert_no_update,
            wechat_alert_on,
            exclude_own_comment,
            custom_fields,
            merged,
            query,
            efq,
            patent_type_and_country,
            ignore_title_length
        },
        transformCode: true
    }).then(({ data }) => {
        return data.data || {};
    });
}

export function getEmailAlertUnusedTitleApi() {
    return psHttp({
        url: `${emailAlertApiUrlPrefix}/emailalert/alert/default-title`,
        method: 'GET',
        transformCode: true
    }).then(({ data }) => {
        return data.data || '';
    });
}

export function getFolderEmailAlertStatusApi(folder_id) {
    return psHttp({
        url: `${emailAlertApiUrlPrefix}/emailalert/alert/search?folder_id=${folder_id}`,
        method: 'GET',
        transformCode: true
    }).then(({ data }) => {
        return data.data || '';
    });
}

export function getEmailAlertListApi(params) {
    return psHttp({
        url: `${emailAlertApiUrlPrefix}/emailalert/alert`,
        method: 'GET',
        params,
        transformCode: true
    }).then(({ data }) => {
        return data.data || '';
    });
}

export function getEmailAlertLimitApi() {
    return psHttp({
        url: `${emailAlertApiUrlPrefix}/emailalert/alert/limitation`,
        method: 'GET',
        transformCode: true
    }).then(({ data }) => {
        return data.data || '';
    });
}

export function getFileWrapperStatusByApnoApi(data) {
    return psHttp({
        url: `${emailAlertApiUrlPrefix}/emailalert/alert/filewrapper/check`,
        method: 'POST',
        data,
        transformCode: true
    }).then(({ data }) => {
        return data.data || '';
    });
}

export function createFileWrapperApi(data) {
    return psHttp({
        url: `${emailAlertApiUrlPrefix}/emailalert/alert/filewrapper`,
        method: 'POST',
        data,
        transformCode: true
    }).then(({ data }) => {
        return data.data || '';
    });
}

export function alertMergeApi({ alertId, queryData }) {
    return psHttp({
        url: `${emailAlertApiUrlPrefix}/emailalert/alert/merge/${alertId}`,
        method: 'PUT',
        data: queryData,
        // transformCode: true
    }).then(data => {
        return data || {};
    });
}

export function getEmailAddressListApi(keyword) {
    return psHttp({
        url: `${emailAlertApiUrlPrefix}/emailalert/alert/email/address/search`,
        method: 'GET',
        params: { keyword },
        transformCode: true,
        headers: { 'X-API-Version': '1.0' }
    }).then(({ data }) => {
        return data.data || '';
    });
}

export function getEmailAlertPreviewApi({
    query,
    efq,
    start_date,
    end_date,
    types,
    patent_type_and_country,
    alert_source,
    alert_id
}) {
    return psHttp({
        url: `${emailAlertApiUrlPrefix}/emailalert/alert/preview`,
        method: 'POST',
        data: {
            query,
            efq,
            start_date,
            end_date,
            types,
            patent_type_and_country,
            alert_source,
            alert_id
        },
        transformCode: true,
    }).then(({ data, }) => {
        return data.data || '';
    });
}
